import React from 'react';

import { useFrequentPassageRequests } from '../../../../hooks/api/frequent-passage-requests/useFrequentPassageRequests';
import { CrewMember, Registration } from '../../../../hooks/api/utils/types';
import CrewMemberSelector from '../../../forms/standard-fields/CrewMemberSelector';
import RegistrationSelector from '../../../forms/standard-fields/RegistrationSelector';
import TextField from '../../../forms/standard-fields/TextField';
import FrequentPassageRequestDetails from './FrequentPassageRequestDetails';

export default function FrequentPassageManualSearch() {
  const [registration, setRegistration] = React.useState<Registration | null>(null);
  const [crewMember, setCrewMember] = React.useState<CrewMember | null>(null);

  let filters: any = {};
  if (crewMember) {
    filters['filter[crew_member_id]'] = crewMember.id;
  }
  if (registration) {
    filters['filter[registration_id]'] = registration.id;
  }

  const { data: frequentPassageRequests } = useFrequentPassageRequests(registration?.eventId, filters, !!registration);

  return (
    <>
      <div className="m-portlet__body">
        <RegistrationSelector value={registration} onChange={setRegistration} />

        {registration && <CrewMemberSelector registration={registration} onChange={setCrewMember} value={crewMember} />}

        {frequentPassageRequests?.data.map((frequentPassageRequest) => (
          <FrequentPassageRequestDetails
            frequentPassageRequest={frequentPassageRequest}
            key={frequentPassageRequest.id}
          />
        ))}
      </div>
    </>
  );
}
